/**
 * Frames the map on these points. The routes panel floats over the right edge
 * of the map (desktop only), so the right side is padded by `rightInset` to keep
 * pins and routes out from under it. It is 0 on mobile, where the panel is a
 * bottom sheet — otherwise the padding could exceed the map width and make
 * fitBounds collapse to the minimum zoom.
 */
export function fitMapTo(map: google.maps.Map, points: readonly { lat: number; lng: number }[], rightInset: number): void {
  if (points.length === 0) return;
  if (points.length === 1) { map.setCenter(points[0]); map.setZoom(15); return; }
  const bounds = new window.google.maps.LatLngBounds();
  points.forEach(p => bounds.extend(p));
  map.fitBounds(bounds, { top: 60, bottom: 60, left: 60, right: 60 + rightInset });
}
